import { useState } from 'react';
import { Activity, Database, ScrollText, HardDrive, Users, Mail, Sparkles } from 'lucide-react';

import QueriesTab from './QueriesTab';
import TablesTab from './TablesTab';
import LogsTab from './LogsTab';
import PerformanceTab from './PerformanceTab';
import ServerTab from './ServerTab';
import RedisTab from './RedisTab';
import SessionsTab from './SessionsTab';
import QueueTab from './QueueTab';
import AIMasterTab from './AIMasterTab';
import SqlWorkbenchTab from './SqlWorkbenchTab';
import GridboxBackfillTab from './GridboxBackfillTab';

const TABS = [
  { id: 'logs',        label: 'Servisler',   icon: <ScrollText size={15} /> },
  { id: 'performance', label: 'Database',    icon: <Database size={15} /> },
  { id: 'server',      label: 'Sunucu',      icon: <HardDrive size={15} /> },
  { id: 'ai',          label: 'AI Master',   icon: <Sparkles size={15} /> },
  { id: 'sessions',    label: 'Oturumlar',   icon: <Users size={15} /> },
  { id: 'queue',       label: 'Message Queue', icon: <Mail size={15} /> },
  { id: 'queries',     label: 'Sorgular',    icon: <Activity size={15} /> },
  { id: 'tables',      label: 'Tablolar',    icon: <Database size={15} /> },
  { id: 'redis',       label: 'Redis',       icon: <HardDrive size={15} /> },
  { id: 'gridbox-backfill', label: 'GridBox Backfill', icon: <Database size={15} /> },
  { id: 'workbench',   label: 'SQL Workbench', icon: <Database size={15} /> },
] as const;

type TabId = typeof TABS[number]['id'];

export default function MonitoringPage() {
  const [tab, setTab] = useState<TabId>('logs');

  return (
    <div className="flex flex-col gap-4 h-full min-h-[600px]">
      {/* Tab bar */}
      <div className="flex gap-1 border-b border-gray-200">
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px ${
              tab === t.id
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {t.icon}
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="flex-1 min-h-0">
        {tab === 'performance' && <PerformanceTab />}
        {tab === 'server'      && <ServerTab />}
        {tab === 'ai'          && <AIMasterTab />}
        {tab === 'sessions'    && <SessionsTab />}
        {tab === 'queue'       && <QueueTab />}
        {tab === 'queries'     && <QueriesTab />}
        {tab === 'tables'      && <TablesTab />}
        {tab === 'redis'       && <RedisTab />}
        {tab === 'logs'        && <LogsTab />}
        {tab === 'gridbox-backfill' && <GridboxBackfillTab />}
        {tab === 'workbench'   && <SqlWorkbenchTab />}
      </div>
    </div>
  );
}
